export const users = {
    route: 'User administration',
    routeTitle: 'User administration',
    listOfUsers: 'List of users',
    addUser: 'Add user',
    editUser: 'Edit user',
    deleteUser: 'Delete user',
    deleteUserButton: 'Delete',
    deleteUserConfirmTitle: 'Are you sure you want to delete this item?',
    deleteUserConfirmDescription: ['User', 'will be deleted.'],
    loginLabel: 'Login',
    firstNameLabel: 'Name',
    lastNameLabel: 'Surname',
    passwordLabel: 'Password',
    permissionsLabel: 'Permissions',
    permissionsIsAdminTag: 'Administrator',
    permissionsIsTesterTag: 'Tester',
    permissionsIsNotAdminTag: 'User',
    oldPasswordLabel: 'Old password',
    newPasswordLabel: 'New password',
    confirmNewPasswordLabel: 'New confirmation password',
    confirmPasswordLabel: 'Confirmation password',
    confirmPasswordNotCorrect: 'Hmm, passwords not the same. Could you please fix it?',
    addUserAsAdmin: 'Set user as administrator',
    addUserAsTester: 'Set user as tester',
    addUserAsInstaller: 'Set user as installer',
    changeUserPassword: 'Change user password'
};
